import { createAsyncThunk } from '@reduxjs/toolkit';
import { FOfferType, isSuburban } from '../../../../packages/JsonQuery';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { selectLocation } from 'shared/selectors/location';
import { fetchLocation } from 'shared/services/fetchLocation';
import { ISelectKPParams } from 'shared/types/geoSuggest';
import { TLocation } from 'shared/types/location';
import { IThunkApi } from 'shared/types/redux';
import { applyLocation } from './applyLocation';
import { setKpId, updateDomRf, updateOfferType, updateSuburbanOfferFilter } from 'shared/slices/jsonQuery';
import { updateSearchMeta } from '../../searchMeta';
import { trackGeoSuggestAutoOfferChange } from 'shared/utils/analytics';

export const selectKP = createAsyncThunk<void, ISelectKPParams, IThunkApi>(
  'geo/geoSuggest/selectKP',
  async ({ id, regionId }, { getState, dispatch, extra: context }) => {
    const state = getState();
    const currentLocation = selectLocation(state);
    const offerType = selectOfferType(state);
    const locationPromise: Promise<TLocation> = regionId
      ? fetchLocation(context, { regionId }).then(result => result || currentLocation)
      : Promise.resolve(currentLocation);

    const locationInfo = await locationPromise;

    //для КП сразу переключаем регион в фильтрах на тот который пришел из саджеста
    if (locationInfo) {
      dispatch(applyLocation(locationInfo));
    }

    if (!isSuburban(offerType)) {
      dispatch(updateDomRf(null));
      dispatch(updateSuburbanOfferFilter(null));
      dispatch(updateOfferType(FOfferType.Suburban));

      trackGeoSuggestAutoOfferChange(id, offerType);
    }

    dispatch(setKpId(id));
    await dispatch(updateSearchMeta());
  },
);
